export function formatAvailableFrom(availableFrom: string | string[]) {
    switch (availableFrom) {
        case 'now':
            return 'Available now';
        case '1months':
            return 'Available in 1 month';
        case '3months':
            return 'Available in 3 months';
        case '6months':
            return 'Available in 6 months';
        case '12months':
            return 'Available in 1 year';
        default:
            return '';
    }
}
